import { useEffect, useState } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import CustomModalDialog from 'snippets/custom-modal-dialog/custom-modal-dialog'
import EngravingContentModal from 'snippets/engraving-content-modal/engraving-content-modal'

const EngravingProductModal = () => {
  const [contentModal, setContentModal] = useState({})
  const [productEngravingId, setProductEngravingId] = useState(null)
  const [status, setStaus] = useState('AddToCart')
  const [product, setProduct] = useState({})
  const [defautlEngraving, setDefautlEngraving] = useState('')
  const [cartItem, setCartItem] = useState('')


  useEffect(() => {
    globalEmitter.on(emitterProps.modal.show, (engraving) => {
      setContentModal(engraving?.modal || {})
      setProductEngravingId(engraving?.productEngravingId || null)
      setProduct(engraving?.product || {})
      setStaus(engraving?.status || 'AddToCart')
      setDefautlEngraving(engraving?.textEngraving || '')
      setCartItem(engraving?.cartItem || '')
    })

    return () => {
      globalEmitter.off(emitterProps.modal.show, () => { })
    }
  }, [])

  return <CustomModalDialog
    id="engraving-product-modal"
    classMain="w-full sm:max-w-96 md:max-w-106 flex flex-col"
    classHeader="sticky top-0 w-full px-4 py-3.5 text-left border-b modal-dialog-header border-grey-10 font-serif italic text-xl text-default"
    classContent="gift-wrapping-slideout-content flex flex-col flex-1 overflow-y-auto"
    classClose="h-4 w-4 !top-1/2 -translate-y-1/2"
    content={
      <EngravingContentModal
        contentModal={contentModal}
        status={status}
        productEngravingId={productEngravingId}
        product={product}
        defautlEngraving={defautlEngraving}
        cartItem={cartItem}
      />
    }
    type='slideout'
    header={contentModal?.title || 'Engraving'}
  />
}

export default EngravingProductModal
